import React, { useEffect, useMemo, useState } from 'react';
import { StepProps } from '../../types/onboarding';
import { SearchIcon } from 'lucide-react';
const STATES_DATA = [{
  id: 'AL',
  name: 'Alabama',
  path: 'M15,5 L25,5 L25,35 L15,35 L10,20 Z'
}, {
  id: 'AK',
  name: 'Alaska',
  path: 'M5,15 L15,5 L25,10 L35,25 L20,35 L5,25 Z'
}, {
  id: 'AZ',
  name: 'Arizona',
  path: 'M10,5 L30,5 L30,35 L10,35 L5,20 Z'
}, {
  id: 'AR',
  name: 'Arkansas',
  path: 'M10,10 L30,10 L30,30 L10,30 Z'
}, {
  id: 'CA',
  name: 'California',
  path: 'M10,5 L20,5 L30,20 L25,35 L15,35 L5,20 Z'
}, {
  id: 'CO',
  name: 'Colorado',
  path: 'M5,10 L35,10 L35,30 L5,30 Z'
}, {
  id: 'CT',
  name: 'Connecticut',
  path: 'M10,15 L30,15 L30,25 L10,25 Z'
}, {
  id: 'DE',
  name: 'Delaware',
  path: 'M15,10 L25,10 L25,30 L15,30 Z'
}, {
  id: 'FL',
  name: 'Florida',
  path: 'M5,10 L25,10 L35,25 L30,35 L20,20 L5,20 Z'
}, {
  id: 'GA',
  name: 'Georgia',
  path: 'M10,5 L25,5 L30,35 L10,35 Z'
}, {
  id: 'HI',
  name: 'Hawaii',
  path: 'M5,20 L10,25 M15,15 L20,20 M25,10 L35,15'
}, {
  id: 'ID',
  name: 'Idaho',
  path: 'M15,5 L25,5 L25,35 L10,35 L10,20 Z'
}, {
  id: 'IL',
  name: 'Illinois',
  path: 'M15,5 L25,5 L25,35 L15,35 L10,20 Z'
}, {
  id: 'IN',
  name: 'Indiana',
  path: 'M15,10 L25,10 L25,35 L15,35 Z'
}, {
  id: 'IA',
  name: 'Iowa',
  path: 'M10,10 L30,10 L30,30 L10,30 Z'
}, {
  id: 'KS',
  name: 'Kansas',
  path: 'M5,15 L35,15 L35,30 L5,30 Z'
}, {
  id: 'KY',
  name: 'Kentucky',
  path: 'M5,15 L35,15 L30,25 L10,25 Z'
}, {
  id: 'LA',
  name: 'Louisiana',
  path: 'M10,10 L20,10 L20,25 L35,25 L35,35 L10,35 Z'
}, {
  id: 'ME',
  name: 'Maine',
  path: 'M15,5 L30,15 L25,35 L10,25 Z'
}, {
  id: 'MD',
  name: 'Maryland',
  path: 'M5,15 L35,15 L30,25 L15,25 L10,30 L5,25 Z'
}, {
  id: 'MA',
  name: 'Massachusetts',
  path: 'M5,15 L30,15 L35,20 L25,25 L5,25 Z'
}, {
  id: 'MI',
  name: 'Michigan',
  path: 'M10,15 L20,15 L25,25 L20,35 L10,35 Z M25,5 L35,10 L30,15 L20,10 Z'
}, {
  id: 'MN',
  name: 'Minnesota',
  path: 'M15,5 L30,10 L30,35 L10,35 L10,20 Z'
}, {
  id: 'MS',
  name: 'Mississippi',
  path: 'M15,10 L25,10 L25,35 L15,35 Z'
}, {
  id: 'MO',
  name: 'Missouri',
  path: 'M10,10 L30,10 L30,30 L10,30 Z'
}, {
  id: 'MT',
  name: 'Montana',
  path: 'M5,10 L35,10 L35,25 L5,25 Z'
}, {
  id: 'NE',
  name: 'Nebraska',
  path: 'M5,15 L35,15 L35,30 L5,30 Z'
}, {
  id: 'NV',
  name: 'Nevada',
  path: 'M10,5 L30,5 L30,35 L10,15 Z'
}, {
  id: 'NH',
  name: 'New Hampshire',
  path: 'M15,5 L25,5 L25,35 L10,35 Z'
}, {
  id: 'NJ',
  name: 'New Jersey',
  path: 'M15,10 L25,10 L20,35 L10,25 Z'
}, {
  id: 'NM',
  name: 'New Mexico',
  path: 'M10,10 L30,10 L30,30 L10,30 Z'
}, {
  id: 'NY',
  name: 'New York',
  path: 'M10,5 L25,5 L35,15 L30,25 L20,20 L10,25 L5,15 Z'
}, {
  id: 'NC',
  name: 'North Carolina',
  path: 'M5,15 L35,15 L30,25 L5,25 Z'
}, {
  id: 'ND',
  name: 'North Dakota',
  path: 'M5,10 L35,10 L35,25 L5,25 Z'
}, {
  id: 'OH',
  name: 'Ohio',
  path: 'M10,10 L30,10 L30,30 L15,30 L10,20 Z'
}, {
  id: 'OK',
  name: 'Oklahoma',
  path: 'M5,15 L35,15 L35,30 L15,30 L15,20 L5,20 Z'
}, {
  id: 'OR',
  name: 'Oregon',
  path: 'M5,10 L35,10 L35,30 L5,30 Z'
}, {
  id: 'PA',
  name: 'Pennsylvania',
  path: 'M5,15 L35,15 L35,30 L5,30 Z'
}, {
  id: 'RI',
  name: 'Rhode Island',
  path: 'M15,15 L25,15 L25,25 L15,25 Z'
}, {
  id: 'SC',
  name: 'South Carolina',
  path: 'M10,15 L30,15 L20,30 L10,25 Z'
}, {
  id: 'SD',
  name: 'South Dakota',
  path: 'M5,10 L35,10 L35,25 L5,25 Z'
}, {
  id: 'TN',
  name: 'Tennessee',
  path: 'M5,15 L35,15 L35,25 L5,25 Z'
}, {
  id: 'TX',
  name: 'Texas',
  path: 'M15,5 L25,5 L30,15 L35,25 L25,35 L15,30 L5,20 L10,10 Z'
}, {
  id: 'UT',
  name: 'Utah',
  path: 'M10,10 L30,10 L30,35 L10,35 Z'
}, {
  id: 'VT',
  name: 'Vermont',
  path: 'M15,5 L25,5 L20,35 L10,35 Z'
}, {
  id: 'VA',
  name: 'Virginia',
  path: 'M5,15 L35,15 L25,25 L5,25 Z'
}, {
  id: 'WA',
  name: 'Washington',
  path: 'M5,10 L35,10 L35,30 L5,30 L5,20 L10,15 Z'
}, {
  id: 'WV',
  name: 'West Virginia',
  path: 'M10,15 L25,10 L30,20 L20,30 L10,25 Z'
}, {
  id: 'WI',
  name: 'Wisconsin',
  path: 'M10,10 L25,10 L30,20 L25,35 L10,35 Z'
}, {
  id: 'WY',
  name: 'Wyoming',
  path: 'M5,10 L35,10 L35,30 L5,30 Z'
}];
export function StatesLicensed({
  data,
  updateData,
  setCanAdvance
}: StepProps) {
  const [searchQuery, setSearchQuery] = useState('');
  useEffect(() => {
    setCanAdvance(true);
  }, [setCanAdvance]);
  const toggleState = (id: string) => {
    const current = data.statesLicensed;
    const newValues = current.includes(id) ? current.filter(v => v !== id) : [...current, id];
    updateData({
      statesLicensed: newValues
    });
  };
  const filteredStates = useMemo(() => {
    const query = searchQuery.toLowerCase();
    return STATES_DATA.filter(state => state.name.toLowerCase().includes(query) || state.id.toLowerCase().includes(query));
  }, [searchQuery]);
  const selectedCount = data.statesLicensed.length;
  return <div className="space-y-6" data-id="element-401" data-mp="2r2awqqsodkin">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-402" data-mp="2r56sq9kypz4g">
        <h3 className="text-sm font-medium text-gray-700" data-id="element-403" data-mp="350hkvf7to654">
          Select Licensed States
        </h3>
        <div className="bg-navy-50 text-navy-600 px-3 py-1 rounded-full text-xs font-semibold" data-id="element-404" data-mp="30z5uv8l1diwe">
          {selectedCount} of 50 selected
        </div>
      </div>

      <div className="relative" data-id="element-405" data-mp="16oajxzmdprqg">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-406" data-mp="16pbxqbus4sbv">
          <SearchIcon className="h-4 w-4 text-gray-400" data-id="element-407" data-mp="35ttt2msfndw3" />
        </div>
        <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="block w-full pl-9 pr-3 py-2 border border-gray-300 rounded-lg leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-navy-600 focus:border-navy-600 sm:text-sm transition-colors" placeholder="Search states by name or abbreviation..." data-id="element-408" data-mp="3arc72rlb4jay" />
      </div>

      <div className="grid grid-cols-3 md:grid-cols-5 lg:grid-cols-6 gap-3" data-id="element-409" data-mp="2ah5rgk5r6yz">
        {filteredStates.map(state => {
        const isSelected = data.statesLicensed.includes(state.id);
        return <button key={state.id} onClick={() => toggleState(state.id)} className={`flex flex-col items-center justify-center p-3 rounded-xl border transition-colors ${isSelected ? 'border-navy-600 bg-navy-50 shadow-md ring-1 ring-navy-600/20' : 'border-gray-200 bg-white shadow-sm hover:border-gray-300 hover:bg-gray-50'}`} data-id="element-410" data-mp="ca7xxbl8x9vw">
              <svg viewBox="0 0 40 40" className={`w-10 h-10 mb-2 transition-colors ${isSelected ? 'fill-navy-600' : 'fill-gray-300'}`} data-id="element-411" data-mp="1rrmf4w5y9nut">
                <path d={state.path} data-id="element-412" data-mp="2kgjvuuuijclg" />
              </svg>
              <span className={`text-base font-bold leading-none ${isSelected ? 'text-navy-600' : 'text-gray-900'}`} data-id="element-413" data-mp="2kga0ssum2f8w">
                {state.id}
              </span>
              <span className={`text-[10px] mt-1 leading-none text-center ${isSelected ? 'text-blue-700' : 'text-gray-500'}`} data-id="element-414" data-mp="2apfhnxcnvvro">
                {state.name}
              </span>
            </button>;
      })}
      </div>

      {filteredStates.length === 0 && <div className="text-center py-12" data-id="element-415" data-mp="2yf9syahc1c9t">
          <p className="text-sm text-gray-500" data-id="element-416" data-mp="26t9quo0c7yg1">
            No states found matching "{searchQuery}"
          </p>
        </div>}
    </div>;
}